/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, gsap, Swiper) => {

        /*
        |
        | Constants
        |------------
        */
        const
            $cardCptPortfolio  = $('.card-cpt.cpt-portfolios'),
            $modalPreview      = $('#modal-preview'),
            $modalSlider       = $('#modal-slider')
        ;

        /*
        |
        | Ajax vars
        |--------------
        */ 
        let
            xhr  = null,
            url  = null,
            lang = document.querySelector('body').dataset.lang,
            id   = null
        ;

        /*
        |
        | Load one ajax
        |--------------
        */
        $cardCptPortfolio.on('click', function(e){

            e.preventDefault();

            let currentTarget = e.currentTarget;

            id = currentTarget.dataset.id,

            $modalPreview.get(0).dataset.postId = id;
            $modalSlider.get(0).dataset.postId = id;

            $modalPreview.iziModal('open');
            
        });

        /*
        |
        | Modals (IziModal)
        |--------------
        */
        $modalPreview.iziModal({

            width: 1200,
            height: 735,
            padding: 48,
            zindex: 990,
 
            onOpening: function(modal){
        
                modal.startLoading();

                let postId = $modalPreview.get(0).dataset.postId;

                url = `/ajax/portfolio/${lang}/${postId}/`;
        
                $.get(`${url}`, function(data) {

                    $modalPreview.find('.container-ajax').html(data);
        
                    let $modalImgs = $('#modal-preview').find('img');
                    
                    modal.stopLoading();

                    $modalImgs.on('click', (e) => {

                        let
                            currentTarget = e.currentTarget,
                            currentImgId  = currentTarget.dataset.index
                        ;

                        $modalSlider.get(0).dataset.currentSlide = currentImgId;

                        $modalSlider.iziModal('open');

                    });

                }, "json" );

            },
            onOpened: function(modal){

                let
                    $modal             = modal.$element,
                    $modalPreviewClose = $modal.find('.close-btn')
                ;

                $modalPreviewClose.on('click', (e) => {

                    e.preventDefault();

                    $modalPreview.iziModal('close');

                });

            },
        
        });

        $modalSlider.iziModal({

            width: 1200,
            height: 735,
            overlayColor: 'rgba(0, 0, 0, 0.6)',

            onOpening: function(modal){

                modal.startLoading();

                let
                    postId       = $modalSlider.get(0).dataset.postId,
                    currentSlide = $modalSlider.get(0).dataset.currentSlide
                ;

                url = `/ajax/portfolio2/${lang}/${postId}/`;

                $.get(`${url}`, function(data) {

                    $modalSlider.find('.container-ajax').html(data);

                    let
                        $swiperModal   = $('#modal-slider').find('.swiper-modal-portfolio'),
                        $closeBtnModal = $('#modal-slider').find('.close-btn')
                    ;

                    const swiperModal = new Swiper($swiperModal.get(0), {
                        // Optional parameters
                        // init: false,
                        loop: true,
                        
                        // Navigation arrows
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // on: {
                        //     init: function () {
                        //         console.log('swiper initialized');
                        //     },
                        //     destroy: function () {
                        //         console.log('swiper destroyed');
                        //     },
                        // },
                    });

                    swiperModal.slideToLoop(currentSlide);

                    $closeBtnModal.removeAttr('style');

                    modal.stopLoading();

                }, "json" );

            },
            onOpened: function(modal){

                let
                    $modal             = modal.$element,
                    $modalSliderClose = $modal.find('.close-btn')
                ;

                $modalSliderClose.on('click', (e) => {

                    e.preventDefault();

                    $modalSlider.iziModal('close');

                });

            },
            onClosing: function(modal){

                $modalSlider.get(0).dataset.currentSlide = '';

                let $swiperModal = $('#modal-slider').find('.swiper-modal-portfolio');

                const swiperModal = $swiperModal.get(0).swiper;

                swiperModal.destroy();

            },
        
        });


        /*
        |
        | Ajax
        |--------------
        */
        const Ajax = (url) => {

            abort(xhr);

            xhr = $.ajax({

                url: url,
                type: 'GET',
                method: 'GET',
                dataType: 'json',
                beforeSend: () => {

                    // gsap.to(
                    //     $loadMore,
                    //     {
                    //         autoAlpha: 0,
                    //         y: 20,
                    //         display: 'none',
                    //         duration: 0.5,
                    //         ease: 'Power1.easeOut',
                    //         onComplete: () => {
                    //             gsap.fromTo(
                    //                 $loaderContainer,
                    //                 {
                    //                     autoAlpha: 0,
                    //                     y: 20,
                    //                     display: 'none'
                    //                 },
                    //                 {
                    //                     autoAlpha: 1,
                    //                     y: 0,
                    //                     display: 'block',
                    //                     duration: 0.5,
                    //                     ease: 'Power1.easeOut'
                    //                 }
                    //             )
                    //         }
                    //     }
                    // );

                },
                success: (response, status) => {
                    
                    // Append Ajax response
                    // $postsContainer.append(response);
                    console.log( response );

                    // ScrollTrigger.refresh();

                    xhr = null;
                },
                error: (response, status, error) => {
                    console.log(error);
                }

            });

        }

        /*
        | HELPER
        |
        | abort ajax request
        |------------
        */
        function abort(xhrVar, $list = null){
            if (xhrVar !== null) {
                xhrVar.abort();
            }

            if($list !== null){
                $list.find('.loading--ajax').hide();
            }
        }

    }
}
